import { all, call, put, select, take, takeLatest } from 'redux-saga/effects';
import {
  setDisableSounds,
  setOnlyMyWatchers,
  fetchMenuSettings,
  fetchMenuSettingsSuccess,
  fetchMenuSettingsFailure,
} from '../actions/settings';
import { damzOnline } from '../actions/initialization';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { createFormData } from '@wix/da-http-client/pkg/utils';
import { PapiRequestDamzSettings } from '@wix/da-papi-types';
import { getIsOnlyMyWatchers, getIsSoundDisabled } from '../selectors/settings';
import i18next from 'i18next';
import { addErrorNotification } from '@wix/da-shared-react/pkg/Notifications/redux/actionCreators';

function* handleSaveUserSettings(
  action: ReturnType<typeof setDisableSounds> | ReturnType<typeof setOnlyMyWatchers>
) {
  try {
    const disableSounds = yield select(getIsSoundDisabled);
    const onlyWatchers = yield select(getIsOnlyMyWatchers);

    const payload: PapiRequestDamzSettings = {
      disable_sounds: (action.payload as { disable: boolean }).disable ?? disableSounds,
      only_watch: (action.payload as { only: boolean }).only ?? onlyWatchers,
    };
    const formData = createFormData<PapiRequestDamzSettings>(payload);
    const response = yield call(
      requestPuppy,
      {
        url: 'settings',
        method: 'POST',
        data: formData,
      },
      () => {
        return {
          success: true,
        };
      },
      'damz'
    );

    if (!response || isApiError(response)) {
      /* v8 ignore next 3 */
      yield put(addErrorNotification(i18next.t('damz.settings.saveError')));
      return;
    }
  } catch (e) {
    yield put(addErrorNotification(i18next.t('damz.settings.saveError')));
  }
}

function* handleFetchMenuSettings() {
  try {
    const response = yield call(
      requestPuppy,
      {
        url: 'settings/menu',
        method: 'GET',
      },
      () => {
        return {
          hasLegacyNotes: false,
          hasLegacyChat: false,
        };
      },
      'damz'
    );
    if (response && !isApiError(response)) {
      yield put(fetchMenuSettingsSuccess(response));
    } else {
      yield put(fetchMenuSettingsFailure());
    }
  } catch (e) {
    yield put(fetchMenuSettingsFailure());
  }
}

export function* settingsSaga() {
  yield take(damzOnline); // wait for online to happen
  yield all([
    takeLatest(fetchMenuSettings, handleFetchMenuSettings),
    takeLatest([setDisableSounds, setOnlyMyWatchers], handleSaveUserSettings),
  ]);
}
